export default __webpack_public_path__ + "static/media/regression_top.e98ee79f.png";